import { render, staticRenderFns } from "./TextOverlay.vue?vue&type=template&id=3f22339d&"
import script from "./TextOverlay.vue?vue&type=script&lang=js&"
export * from "./TextOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports